module.exports = __webpack_public_path__ + "img/poke-salmon.4bd1ca3d.png";